import { useEffect } from 'react';

export function useBeforeUnloadGuard(dirtyRef: React.MutableRefObject<boolean>) {
    useEffect(() => {
        const handler = (e: BeforeUnloadEvent) => {
            if (!dirtyRef.current) return;
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [dirtyRef]);
}
